<template>
<div class="login">
    <info-section />
    <login-form />
</div>
</template>

<script>
import InfoSection from "./InfoSection.vue";
import LoginForm from "./LoginForm.vue";
export default {
  name: 'index',
    components: {LoginForm, InfoSection},
};
</script>

<style lang="scss">
.login {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    align-items: stretch;
    flex-shrink: 0;
    color: white;
}
</style>
